// Which editor a saved area opens in. One rule, used by the Library and the Activities area
// picker. Pure: no React, router or Firebase imports.
import { ROAD_LINK_TYPES } from '../config/countries';

/** The route of the editor for an area type: custom polygons, road links, or the standard polygon picker. */
export function areaEditPath(type: string): string {
  if (type === 'custom_polygon') return '/custom-polygon';
  if (ROAD_LINK_TYPES.includes(type)) return '/road-links';
  return '/polygon-select';
}
